import jsPDF from 'jspdf'
import * as logoPemda from '@/config/logo-pemda'
import moment from 'moment'

const DINAS = 'SEKRETARIAT DAERAH KABUPATEN GARUT'
const ALAMAT = 'Sukagalih, Kec. Tarogong Kidul, Kabupaten Garut,'

const ALAMAT2 = 'Jawa Barat 44151 Telepon: (0262) 232225'

const centerText = function(doc, text, y) {
  var textWidth =
    (doc.getStringUnitWidth(text) * doc.internal.getFontSize()) /
    doc.internal.scaleFactor
  var textOffset = (doc.internal.pageSize.width - textWidth) / 2
  doc.text(textOffset, y, text)
}

export const createTandaTerima = function(item) {
  const topMargin = 15
  const leftMargin = 10
  const rightMargin = 10
  // const doc = new jsPDF('l', 'pt', [pageWidth, pageHeight])
  const doc = new jsPDF()
  const pageWidth = doc.internal.pageSize.width
  let yHeader = topMargin
  doc.setFont('times', 'bold')
  doc.setFontSize(12)
  doc.addImage(logoPemda.imageData, 'JPEG', leftMargin, 10, 25, 25)
  centerText(doc, DINAS, yHeader)

  doc.setFontSize(16)
  yHeader += 7
  centerText(doc, 'BAGIAN UMUM', yHeader)

  doc.setFontSize(11)
  doc.setFont('times', 'normal')
  yHeader += 7
  centerText(doc, ALAMAT, yHeader)
  yHeader += 5
  centerText(doc, ALAMAT2, yHeader)

  doc.setFontSize(11)
  yHeader += 7
  doc.setFont('times', 'bold')
  doc.line(
    leftMargin,
    yHeader,
    doc.internal.pageSize.width - rightMargin,
    yHeader
  )
  yHeader += 5
  centerText(doc, 'TANDA TERIMA', yHeader)
  yHeader += 3
  doc.line(
    leftMargin,
    yHeader,
    doc.internal.pageSize.width - rightMargin,
    yHeader
  )

  let y = yHeader + 20
  const xColon = 50
  const afterXColon = xColon + 3
  const yInc = 7

  doc.rect(pageWidth - 40, yHeader + 5, 30, 10)
  doc.text(
    pageWidth - (item.is_tembusan ? 36 : 30),
    y - 9,
    item.is_tembusan ? 'TEMBUSAN' : 'ASLI'
  )

  doc.setFontSize(12)
  doc.setFont('times', 'normal')

  doc.text('Telah terima dari', 15, y)
  doc.text(xColon, y, ':')
  doc.text(item.pengirim, afterXColon, y)
  y += yInc

  doc.text('No. Surat', 15, y)
  doc.text(xColon, y, ':')
  doc.text(afterXColon, y, item.no)
  y += yInc

  doc.text('Tgl. Surat', 15, y)
  doc.text(xColon, y, ':')
  const tanggalSuratDate = new Date(item.tgl_surat)
  const tanggalSuratString =
    ('0' + tanggalSuratDate.getDate()).slice(-2) +
    ' ' +
    monthNames[tanggalSuratDate.getMonth()] +
    ' ' +
    tanggalSuratDate.getFullYear()
  doc.text(afterXColon, y, tanggalSuratString)
  y += yInc

  doc.text('Perihal', 15, y)
  doc.text(xColon, y, ':')
  const maxLength = pageWidth - (leftMargin + afterXColon) - rightMargin
  const splitText = doc.splitTextToSize(item.perihal, maxLength)
  doc.text(afterXColon, y, splitText)
  y += yInc * splitText.length - (splitText.length - 1) * splitText.length * 2.3

  doc.text('Nomor Kendali', 15, y)
  doc.text(xColon, y, ':')
  doc.text(afterXColon, y, item.index_surat_tu)
  y += yInc

  let diarahkanKe = []
  if (item.tujuan && Array.isArray(item.tujuan) && item.tujuan.length) {
    diarahkanKe = item.tujuan.map(tj => tj.name)
  }
  if (item.tembusan && Array.isArray(item.tembusan) && item.tembusan.length) {
    diarahkanKe = [...diarahkanKe, ...item.tembusan.map(tj => tj.name)]
  }
  diarahkanKe = diarahkanKe.join(', ')

  doc.text('Diarahkan ke', 15, y)
  doc.text(xColon, y, ':')
  doc.text(afterXColon, y, diarahkanKe)
  y += 14

  const tanggalMasukDate = new Date(item.tgl_masuk)
  const tanggalMasukString =
    ('0' + tanggalMasukDate.getDate()).slice(-2) +
    ' ' +
    monthNames[tanggalMasukDate.getMonth()] +
    ' ' +
    tanggalMasukDate.getFullYear()
  doc.text(pageWidth - rightMargin - 55, y, `Garut, ${tanggalMasukString}`)
  y += yInc
  doc.text(pageWidth - rightMargin - 47, y, 'PENERIMA')
  y += yInc * 4
  doc.text(pageWidth - rightMargin - 65, y, '____________________________')
  return doc.output('dataurlnewwindow')
}

export const createkartuSuratKeluar = function(item) {
  const topMargin = 15
  const leftMargin = 10
  const rightMargin = 10

  const doc = new jsPDF()
  let yHeader = topMargin
  doc.setFont('times', 'bold')
  doc.setFontSize(12)
  doc.addImage(logoPemda.imageData, 'JPEG', leftMargin, 10, 25, 25)
  centerText(doc, DINAS, yHeader)

  doc.setFontSize(16)
  yHeader += 7
  centerText(doc, 'BAGIAN UMUM', yHeader)

  doc.setFontSize(11)
  doc.setFont('times', 'normal')
  yHeader += 7
  centerText(doc, ALAMAT, yHeader)
  yHeader += 5
  centerText(doc, ALAMAT2, yHeader)

  doc.setFontSize(11)
  yHeader += 7
  doc.setFont('times', 'bold')
  doc.line(
    leftMargin,
    yHeader,
    doc.internal.pageSize.width - rightMargin,
    yHeader
  )
  yHeader += 5
  centerText(doc, 'KARTU SURAT KELUAR', yHeader)
  yHeader += 3
  doc.line(
    leftMargin,
    yHeader,
    doc.internal.pageSize.width - rightMargin,
    yHeader
  )

  let y = yHeader + 10
  const xColon = 50
  const afterXColon = xColon + 3
  const yInc = 7

  doc.setFontSize(12)
  doc.setFont('times', 'normal')

  const content = [
    { label: 'Indeks', value: item.klasifikasi ? item.klasifikasi.jenis : '-' },
    { label: 'Kode', value: item.kode },
    { label: 'No. Urut', value: item.index_surat },
    {
      label: 'Tgl. Surat',
      value: item.tgl_surat
        ? moment(item.tgl_surat, 'YYYY-MM-DD').format('DD-MM-YYYY')
        : ''
    },
    { label: 'Pengolah', value: item.nama_bidang },
    { label: 'Nomor Surat', value: item.index_surat_tu },
    { label: 'Perihal', value: item.perihal },
    { label: 'Tujuan', value: item.tujuan },
    { label: 'Isi Ringkas', value: item.ringkasan }
  ]

  content.forEach(c => {
    doc.text(c.label, 15, y)
    doc.text(xColon, y, ':')
    doc.text(`${c.value || '-'}`, afterXColon, y)
    y += yInc
  })

  return doc.output('dataurlnewwindow')
}

export const monthNames = [
  'Januari',
  'Februari',
  'Maret',
  'April',
  'Mei',
  'Juni',
  'Juli',
  'Agustus',
  'September',
  'Oktober',
  'November',
  'Desember'
]
